import { render } from "./FloatingView.vue?vue&type=template&id=bf503c74"
import script from "./FloatingView.vue?vue&type=script&lang=js"
export * from "./FloatingView.vue?vue&type=script&lang=js"

import "./FloatingView.vue?vue&type=style&index=0&id=bf503c74&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__